import type { RunInputs, RunOutputs } from "@/types/content";

import { safeParse } from "./json";

export const parseRunOutputs = (raw: string | null | undefined): RunOutputs =>
  safeParse<RunOutputs>(raw, {});

export const parseRunInputs = (raw: string | null | undefined): RunInputs =>
  safeParse<RunInputs>(raw, {});

const isValidUrl = (value: string): boolean => {
  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
};

export const getRunImageUrls = (outputs: RunOutputs): string[] => {
  if (outputs.image_urls?.length) {
    return outputs.image_urls.filter((u) => u && isValidUrl(u));
  }
  return outputs.image_url && isValidUrl(outputs.image_url) ? [outputs.image_url] : [];
};
